import type {PlanActions} from '../../hooks/useCategoryPlan';
import type {CategoryPlan} from '../../types/strategyTypes';

/** What every Strategy tab section receives. */
export type PlanProps = {plan: CategoryPlan; actions: PlanActions; money: (v: number) => string; databagId: number; path: string};

export const PICK_COLORS = {Implement: '#2E7D32', Challenge: '#2D6FF5', Possible: '#ED6C02', Kill: '#9E9E9E'} as const;
export const TONE_COLORS = {good: 'success.main', warn: 'warning.main', bad: 'error.main'} as const;
